export default __webpack_public_path__ + "static/media/ibm_logo.8204bba7.png";